import { createContext, useContext } from 'react';

export const BizContext = createContext(null);
export const useBiz = () => useContext(BizContext);
